import { render, staticRenderFns } from "./Overview.vue?vue&type=template&id=c4c7451e&scoped=true&"
import script from "./Overview.vue?vue&type=script&lang=ts&setup=true&"
export * from "./Overview.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./Overview.vue?vue&type=style&index=0&id=c4c7451e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c7451e",
  null
  
)

export default component.exports